import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { useSelector } from 'react-redux'

import { FEATURE_FLAGS } from '@/config'
import { JOB_LP, JOBS_GENERIC_LP } from '@/page/constants'
import { getPageType } from '@/page/store/selectors'
import { getResultsSearchParams } from '@/results/store/selectors'

import JobHeader from '../../jobDetail/components/JobHeader'
import PropTypesHelpers from '../../utils/propTypesHelpers'

export const SearchResultsListJobItem = ({ item, active, onClick, target, className, titleTag }) => {
  const pageType = useSelector(getPageType)
  const searchQuery = useSelector(getResultsSearchParams)
  const { show_ad_text_snipped: showAdTextSnippet } = FEATURE_FLAGS

  return (
    <a
      href={item.url}
      className={classnames('search-result-item', { active, premium: item.highlight }, className)}
      onClick={onClick}
      target={target}
    >
      <div className='list-group-item w-100'>
        <JobHeader jobInfo={item} searchQuery={searchQuery} titleTag={titleTag} />
        {[JOB_LP, JOBS_GENERIC_LP].includes(pageType) && item.snippet && (!showAdTextSnippet || showAdTextSnippet.value) &&
          <p className='search-result-item__snippet qa-sri-snp'>{item.snippet}</p>}
      </div>
    </a>
  )
}

SearchResultsListJobItem.propTypes = {
  className: PropTypesHelpers.classnames,
  item: PropTypes.shape({
    highlight: PropTypes.bool,
    snippet: PropTypes.string,
    url: PropTypes.string
  }).isRequired,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  target: PropTypes.string,
  titleTag: PropTypes.node
}

export default SearchResultsListJobItem
